/**
 * OwnershipTab — Ownership History timeline + Current Ownership by tier.
 * Matches eliotnest_core's facility ownership layout.
 */
import React from 'react';
import {
  Box,
  Typography,
  Alert,
} from '@mui/material';
import { OwnershipData } from '../../types';
import OwnershipTimeline from './OwnershipTimeline';
import OwnershipSnapshot from './OwnershipSnapshot';

interface Props {
  ccn: string;
  ownershipData: OwnershipData;
  onNavigate: (ccn: string) => void;
}

export default function OwnershipTab({ ccn, ownershipData, onNavigate }: Props) {
  const { owners, chow_events, ownership_periods, org_name, dba_name } = ownershipData;

  return (
    <Box>
      {/* Facility Identity */}
      {(org_name || dba_name) && (
        <Box sx={{ mb: 3 }}>
          {org_name && (
            <Typography variant="body1" sx={{ color: '#102B3D' }}>
              <strong>Organization:</strong> {org_name}
            </Typography>
          )}
          {dba_name && dba_name !== org_name && (
            <Typography variant="body2" color="text.secondary">
              Doing Business As: {dba_name}
            </Typography>
          )}
        </Box>
      )}

      {/* Ownership History Timeline */}
      {ownership_periods && ownership_periods.length > 0 && (
        <OwnershipTimeline
          ownershipPeriods={ownership_periods}
          chowEvents={chow_events}
        />
      )}

      {/* Current Ownership by Tier */}
      {owners.length === 0 ? (
        <Alert severity="info" sx={{ mb: 3 }}>No ownership data available.</Alert>
      ) : (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            Current Ownership
          </Typography>
          <OwnershipSnapshot
            owners={owners}
            otherFacilities={ownershipData.other_facilities || []}
            facilityState=""
          />
        </Box>
      )}
    </Box>
  );
}
